import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const AuthGuard = ({ children }) => {
  const { user, loading, cleanupWorkers } = useContext(AuthContext);
  const location = useLocation();
  const publicPaths = ['/login', '/forgot-password', '/reset-password'];
  const isPublicPath = publicPaths.includes(location.pathname);

  // Clean up workers when route changes to avoid duplicates
  useEffect(() => {
    return () => {
      if (cleanupWorkers) cleanupWorkers();
    };
  }, [location.pathname, cleanupWorkers]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Always allow access to reset-password page
  if (location.pathname === '/reset-password') {
    return children;
  }

  if (!user && !isPublicPath) {
    // Clean up workers before redirecting
    if (cleanupWorkers) cleanupWorkers();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user && isPublicPath) {
    // Clean up workers before redirecting
    if (cleanupWorkers) cleanupWorkers();
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthGuard;